import React, { useState, useRef } from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'

import TournamentName from '../Components/TournamentName'
import WaterBody, { findLabelByValue } from '../Components/WaterBody'
import CompetitionType from '../Components/CompetitionType'
import CompetitionFormatted from '../Components/CompetitionFormatted'
import CompetitionDraw from '../Components/CompetitionDraw'
import CompetitionSelectWinners from '../Components/CompetitionSelectWinners'
import CompetitionProtocols from '../Components/CompetitionProtocols'
import CompetitionDopNomination from '../Components/CompetitionDopNomination'
import CompetitionDate from '../Components/CompetitionDate'
import CompetitionDuration from '../Components/CompetitionDuration'
import { getData, addData, addRequestsData } from '../../api/indexedDBHandler'
import { formatDateToDDMMYYYY } from '../../api/formatDate'
import { useNavigate } from 'react-router-dom'
import { Grid2 } from '@mui/material'

const Registrations = () => {
  const [oneProtocol, setOneProtocol] = React.useState(true)
  // Рефы для дочерних компонентов
  const navigate = useNavigate()

  const tournamentNameRef = useRef(null)
  const competitionDateRef = useRef(null)
  const competitionDurationRef = useRef(null)
  const waterBodyRef = useRef(null)
  const competitionTypeRef = useRef(null)
  const competitionFormattedRef = useRef(null)
  const competitionDrawRef = useRef(null)
  const competitionSelectWinnersRef = useRef(null)
  const competitionProtocolsRef = useRef(null)
  const competitionDopNominationRef = useRef(null)

  const [isDisabled, setDisabled] = useState(false)

  const buttonRegistration = async () => {
    const isTournamentNameValid = tournamentNameRef.current.validate()
    const isCompetitionDateValid = competitionDateRef.current.validate()
    const isCompetitionDurationValid = competitionDurationRef.current.validate()
    const isWaterBodyValid = waterBodyRef.current.validate()
    const isCompetitionTypeValid = competitionTypeRef.current.validate()
    const isCompetitionFormattedValid =
      competitionFormattedRef.current.validate()
    const isCompetitionDrawValid = competitionDrawRef.current.validate()
    const isCompetitionSelectWinnersValid =
      competitionSelectWinnersRef.current.validate()
    const isCompetitionProtocolsValid = oneProtocol
      ? true
      : competitionProtocolsRef.current.validate()

    // Проверяем, прошли ли все компоненты валидацию
    const isFormValid =
      isCompetitionDateValid &&
      isTournamentNameValid &&
      isCompetitionDurationValid &&
      isWaterBodyValid &&
      isCompetitionTypeValid &&
      isCompetitionFormattedValid &&
      isCompetitionDrawValid &&
      isCompetitionSelectWinnersValid &&
      isCompetitionProtocolsValid

    if (isFormValid) {
      setDisabled(true)

      const results = await getData('user', 'created', true)
      const { value } = results[0]
      const idT = value.id_tournaments + '' + Date.now()
      const save_data = {
        id: idT,
        duration: competitionDurationRef.current.val(),
        competition_format: competitionFormattedRef.current.val(),
        tournament_draw: competitionDrawRef.current.val(),
        tournament_name: tournamentNameRef.current.val(),
        competition_type: competitionTypeRef.current.val(),
        start_date: formatDateToDDMMYYYY(
          competitionDateRef.current.val().startDate
        ),
        end_date: formatDateToDDMMYYYY(
          competitionDateRef.current.val().endDate
        ),
        winners: competitionSelectWinnersRef.current.val(),
        protocols: !oneProtocol
          ? competitionProtocolsRef.current.val()
          : 'Отдельные протоколы',
        dop_nomination: competitionDopNominationRef.current.val(),
        banner_url: null,
        count_cups: 1,
        federations: null,
        current_count_cup: 1,
        chatId_for_post_new_team: null,
        threadId_for_post_new_team: null,
        second_chatId_for_post_new_team: null,
        second_threadId_for_post_new_team: null,
        stages_cup_id: '[{"id1":"' + idT + '"}]',
        role: 'Организатор',
        logocup: null,
        phone_org: value.phone,
        status_cup: 'Создан',
        url_for_group_cup_post: null,
        water_id: waterBodyRef.current.val(),
        water_body: findLabelByValue(waterBodyRef.current.val()),
        weigh_fish: 0,
        big_fish_day: 0,
        count_fish: 0,
        count_big_fish: 0,
        first_fish: 0,
        int_count_big_fish: 0,
        token: value.token,
        requestKey: `${value.token}_saveTournaments_${new Date().getTime()}`,
      }
      // const requestKey = `${id}_dellUser_${new Date().getTime()}`
      // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      console.log(save_data)
      await addData('tournaments', {
        ...save_data,
      })

      try {
        await addRequestsData('requests', {
          url: 'tournaments/saveTournaments.php',
          ...save_data,
        })
        await new Promise((resolve) => setTimeout(resolve, 3000))
      } catch (error) {
      } finally {
        navigate('/tournaments-list')
      }
    }
  }

  return (
    <>
      <Box
        mt={1}
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2, // Используем theme.spacing(2) вместо фиксированных значений
          paddingBottom: '130px',
        }}
      >
        <Typography variant="h6" gutterBottom>
          Регистрация нового турнира
        </Typography>
        <TournamentName ref={tournamentNameRef} />
        <Box sx={{ width: '100%' }}>
          <CompetitionDate ref={competitionDateRef} />
        </Box>
        <CompetitionDuration ref={competitionDurationRef} />
        <WaterBody ref={waterBodyRef} />
        <CompetitionType ref={competitionTypeRef} />
        <CompetitionFormatted ref={competitionFormattedRef} />
        <CompetitionDraw ref={competitionDrawRef} />
        <CompetitionSelectWinners
          ref={competitionSelectWinnersRef}
          setOneProtocol={setOneProtocol}
        />
        {!oneProtocol && <CompetitionProtocols ref={competitionProtocolsRef} />}
        <CompetitionDopNomination ref={competitionDopNominationRef} />
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button
            disabled={isDisabled}
            variant="contained"
            color="primary"
            onClick={buttonRegistration}
            sx={{
              borderRadius: '20px',
              padding: '10px 20px',
            }}
          >
            Сохрнаить
          </Button>
        </Box>
      </Box>
    </>
  )
}

export default Registrations

// banner_url: "https://sun9-74.userapi.com/impg/lJiASImgLdbBJYjC-NnlFaTjKsQfrM3QDfVk7g/2pcqEYaYv88.jpg?size=2560x1218&quality=95&sign=f591743cd1e870270b2d1…";
// chatId_for_post_new_team: "-1001744283717";
// logocup: "/logo/cup/asvcuplogo-cdr-2.png";
// second_chatId_for_post_new_team: "-1002428685660";
// second_threadId_for_post_new_team: "13";
// threadId_for_post_new_team: null;
// url_for_group_cup_post: "https://t.me/asvcup";

// count_cups: 1;
// current_count_cup: 1;

// federations: 79;
// stages_cup_id: '[{"id1":"11730096961079"}]';

//!!!22 id: "11730096961079";
//!!!22 duration: 72;
//!!!22  competition_format: "Парные соревнования";
//!!!22 tournament_draw: "Простая";
//!!!22 tournament_name: "ASV CUP";
//!!!22 water_body: "РСК Клондайк";
//!!!22 competition_type: "Коммерческое соревнование";
//!!!22 start_date: "07.05.2025";
//!!!22 end_date: "11.05.2025";

// first_fish: 0;  //!!!
// big_fish_day: 1; //!!!
// count_big_fish: 0; //!!!
// count_fish: 0; //!!!
// int_count_big_fish: 0;  //!!!

// water_id: 3;
// weigh_fish: 1;
// role: "Организатор";
// phone_org: 79962475719;
// status_cup: "Регистрация";
